"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var WizardActions = require("@caddigital/sok-reducers/lib/actions/order/wizard");
var newExternalUserActions = require("@caddigital/sok-reducers/lib/actions/order/newExternalUser");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var AddNewDeliveryAddress_1 = require("components/OrderAndDistributionComponents/AddNewDeliveryAddress");
var Types = require("types");
var mapStateToProps = function (state) { return ({
    newExternalUser: state.order.newExternalUser,
    regions: state.user.region.list
}); };
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    changeAddNewRecipientField: function (field) {
        return function (_a) {
            var value = _a.target.value;
            return dispatch(newExternalUserActions.actions.updateField(field, value));
        };
    },
    createNewExternalUser: function (folder, newRecipient) { return function () {
        return dispatch(newExternalUserActions.actions.createRequest(folder, newRecipient));
    }; },
    clearAddNewRecipient: function () { return (dispatch(newExternalUserActions.actions.clearState()),
        dispatch(WizardActions.step2AddRecipientAddNewDeliveryAddress(false))); }
}); };
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var mapDispatchToPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, mapDispatchToProps), recompose_1.pure);
require("./style.scss");
exports.default = enhance(function (props) { return (React.createElement(sok_ui_1.Modal, { isOpen: props.show, className: 'order-wizard-add-new-external-user' },
    React.createElement(sok_ui_1.Header, { onClose: props.clearAddNewRecipient }, (0, translation_1.getLocalization)('userfront/distributionwizard/step2/newDeliveryAddress')),
    React.createElement(sok_ui_1.Container, null,
        React.createElement(AddNewDeliveryAddress_1.default, { addNewRecipient: props.newExternalUser, currentFolder: props.currentFolder, changeAddNewRecipientField: props.changeAddNewRecipientField, createNewExternalUser: props.createNewExternalUser, clearAddNewRecipient: props.clearAddNewRecipient, regions: props.regions, hideControls: true })),
    React.createElement(sok_ui_1.Footer, null,
        React.createElement(sok_ui_1.Button, { onClick: props.createNewExternalUser(props.currentFolder, props.newExternalUser), color: 'green', text: (0, translation_1.getLocalization)('userfront/order/addressbook/save') }),
        React.createElement(sok_ui_1.Button, { onClick: props.clearAddNewRecipient, color: 'dark-gray', text: (0, translation_1.getLocalization)('userfront/order/addressbook/cancel') })))); });
